export const getNumericalValue = (dimension: string) => {
  if (dimension.endsWith("px")) return Number(dimension.split("px")[0]);
  if (dimension.endsWith("%")) return Number(dimension.split("%")[0]);

  return Number(dimension);
};
